import React from 'react'

import { Address } from '@matech/thebigpos-sdk'

import formatBorrowerAddress from '../utils/formatBorrowerAddress'

type BorrowerAddressCellProps = Readonly<{
	loanId?: string | null
	address?: Address | null
}>

function BorrowerAddressCell({
	loanId,
	address,
}: BorrowerAddressCellProps) {
	const addressLines = formatBorrowerAddress(address)

	return (
		<div className="min-w-0">
			{addressLines.map((line) => (
				<p key={`${loanId}-address`} className="truncate">
					{line}
				</p>
			))}
		</div>
	)
}

export default BorrowerAddressCell
